import React, { useState } from "react";
import { RIDE_OPTIONS } from "../mock";
import { Reveal } from "../hooks/useReveal";
import { Clock, Users as UsersIcon, ArrowRight } from "lucide-react";
import { toast } from "sonner";

export default function RideOptions({ onWaitlist }) {
  const [active, setActive] = useState(RIDE_OPTIONS[1].id);

  return (
    <section id="rides" className="relative py-24 bg-[#0a0e0c] border-y border-white/5">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <Reveal className="text-center max-w-2xl mx-auto">
          <span className="text-xs font-bold uppercase tracking-[0.25em] text-[#2fd645]">The fleet</span>
          <h2 className="mt-3 font-display font-extrabold text-white text-4xl sm:text-5xl">
            A ride for every moment
          </h2>
          <p className="mt-4 text-white/60 text-lg">
            Pick your comfort level and price point. Every option comes with verified drivers and upfront fares.
          </p>
        </Reveal>

        <div className="mt-16 grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {RIDE_OPTIONS.map((r, i) => {
            const Icon = r.icon;
            const isActive = active === r.id;
            return (
              <Reveal key={r.id} delay={i * 90}>
                <button
                  onMouseEnter={() => setActive(r.id)}
                  onFocus={() => setActive(r.id)}
                  onClick={() => setActive(r.id)}
                  className={`relative text-left w-full h-full rounded-3xl border p-7 transition-all duration-300 ${
                    isActive
                      ? "border-[#2fd645]/60 bg-[#0f1613] -translate-y-1 id-glow"
                      : "border-white/10 bg-[#0e1311] hover:border-[#2fd645]/30"
                  }`}
                >
                  {r.popular && (
                    <span className="absolute top-5 right-5 rounded-full bg-[#2fd645] px-2.5 py-1 text-[10px] font-bold uppercase tracking-wide text-[#06210b]">
                      Popular
                    </span>
                  )}
                  <div className="h-13 w-13 p-3 rounded-2xl bg-[#2fd645]/12 border border-[#2fd645]/25 inline-flex">
                    <Icon className="h-7 w-7 text-[#2fd645]" />
                  </div>
                  <h3 className="mt-5 text-xl font-bold text-white">{r.name}</h3>
                  <p className="text-sm text-[#2fd645]/90 font-medium">{r.tagline}</p>
                  <p className="mt-3 text-sm text-white/55 leading-relaxed min-h-[66px]">{r.desc}</p>

                  <div className="mt-4 flex items-center gap-4 text-xs text-white/60">
                    <span className="flex items-center gap-1"><Clock className="h-3.5 w-3.5 text-[#2fd645]" /> {r.eta}</span>
                    <span className="flex items-center gap-1"><UsersIcon className="h-3.5 w-3.5 text-[#2fd645]" /> {r.seats}</span>
                  </div>

                  <div className="mt-5 flex items-center justify-between border-t border-white/10 pt-4">
                    <span className="font-display font-bold text-white text-lg">{r.price}</span>
                    <span
                      role="button"
                      onClick={(e) => { e.stopPropagation(); toast.success(`${r.name} coming at launch!`, { description: "Join the waitlist to be first to book." }); onWaitlist && onWaitlist(); }}
                      className="inline-flex items-center gap-1 text-sm font-semibold text-[#2fd645] hover:gap-2 transition-all"
                    >
                      Reserve <ArrowRight className="h-4 w-4" />
                    </span>
                  </div>
                </button>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
